/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState } from "react";
import loading from "../assets/esign-ui-icons/saving-ico.svg";
import { createContext } from "react";

export const FullPageLoadingContext = createContext({});

const FullPageLoading = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <FullPageLoadingContext.Provider value={{ showFullPageLoading: (e) => setIsLoading(e) }}>
      <div style={{ width: "100%", height: "100%" }}>
        {children}
        {isLoading ? (
          <div
            style={{
              zIndex: 9999,
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255,255,255,.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img id="loading-spinner" src={loading} style={{ width: 20, height: 20 }} />
          </div>
        ) : null}
      </div>
    </FullPageLoadingContext.Provider>
  );
};

export default FullPageLoading;
